import { render } from "./FAQCategory.vue?vue&type=template&id=4def52a2"
import script from "./FAQCategory.vue?vue&type=script&lang=js"
export * from "./FAQCategory.vue?vue&type=script&lang=js"
script.render = render

export default script